import { client, noAuthClient } from "@/queries/client";
import { useMutation, useQuery } from "@tanstack/react-query";

export function getUser({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["me"],
    enabled,
    queryFn: async ({ signal }) => {
      const { data, error } = await client.get().GET("/api/user/me", {
        signal,
      });
      if (data) return data;
      throw new Error(String(error));
    },
  });
}

export function switchSession() {
  return useMutation({
    mutationFn: async (airport: number) => {
      const { data, error } = await client.get().POST("/api/session/new/{id}", {
        params: {
          path: {
            id: airport,
          },
        },
      });
      if (data) return data;
      console.warn(error);
      throw new Error("Failed to switch session");
    },
  });
}

export function resetPassword() {
  return useMutation({
    mutationFn: async ({
      password,
      confirm,
    }: {
      password: string;
      confirm: string;
    }) => {
      const { data, error } = await client.get().POST("/api/user/reset", {
        body: {
          confirm,
          password,
        },
      });
      if (data) return data;
      console.warn(error);
      throw new Error("Failed to reset password");
    },
  });
}

interface ForgotPasswordData {
  email: string;
}

export function useForgotPassword() {
  return useMutation({
    mutationFn: async ({ email }: ForgotPasswordData) => {
      const { data, error } = await noAuthClient.POST("/api/auth/forgot", {
        body: {
          email: email,
        },
      });
      if (data) return data;
      console.warn(error);
      throw new Error("Failed to send password reset email");
    },
  });
}

interface NewPasswordData {
  reset_token: string;
  password: string;
  confirm: string;
}

export function useNewPassword() {
  return useMutation({
    mutationFn: async (body: NewPasswordData) => {
      const { data, error } = await noAuthClient.POST(
        "/api/auth/new-password",
        {
          body,
        }
      );
      if (data) return data;
      console.warn(error);
      throw new Error("Failed to set new password");
    },
  });
}

export function getAirportUsers({
  enabled = true,
}: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["airport", "users"],
    enabled,
    queryFn: async ({ signal }) => {
      const { data, error } = await client.get().GET("/api/airport/users", {
        signal,
      });
      if (data) return data;
      throw new Error(String(error));
    },
  });
}
